export default {
    props: {
      options: {
        type: Array,
        default() { return [] },
      },
      value: {
        twoWay: true,
        type: Array,
        default() {
          return []
        }
      },
      placeholder: {
        type: String,
        default: 'Nothing Selected'
      },
      multiple: {
        type: Boolean,
        default: false
      },
      search: { // Allow searching (only works when options are provided)
      	type: Boolean,
      	default: false
      },
      limit: {
        type: Number,
        default: 1024
      }
    },
    data() {
      return {
        searchText: null,
        show: false,
        showNotify: false
      }
    },
    computed: {
      selectedItems() {
        if (!this.options.length)
        {
          return this.value.join(',');
        }
        else
        {
          // we were given bunch of options, so pluck them out to display
          var foundItems = [];
          for (var item of this.options)
          {
            if (this.value.indexOf(item.value) !== -1)
              foundItems.push(item.label);
          }

          return foundItems.join(', ');
        }
      },
      showPlaceholder() {
        return this.value.length <= 0
      }
    },
    watch: {
      value(val) {
        let timeout
        if (timeout) clearTimeout(timeout)
        if (val.length > this.limit) {
          this.showNotify = true
          this.value.pop()
          timeout = setTimeout(()=> this.showNotify = false, 1000)
        }
      }
    },
    methods: {
      select(v) {
        var index = this.value.indexOf(v);
        if (index === -1)
          this.value.push(v);
        else
          this.value.$remove(v)
      },
      toggleDropdown() {
        this.show = !this.show
      }
    }
  }


/** WEBPACK FOOTER **
 ** ./src/Select.vue
 **/